import React from "react";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
import duration from "dayjs/plugin/duration";
dayjs.extend(weekOfYear);
dayjs.extend(duration);

export default function useSortingDataByWeek(data, type) {
	const [ancienneData, setAncienneData] = React.useState(null);
	const [actuelleData, setActuelleData] = React.useState(null);
	const [futurData, setFuturData] = React.useState(null);

	const numeroSemaineEnCours = dayjs().week();

	React.useEffect(() => {
		const sortingData = () => {
			const ancienne = [];
			const actuelle = [];
			const futur = [];

			data.forEach((item) => {
				const id = item.rowKey.includes("Vente")
					? item.rowKey
							.replace("Vente-Semaine-", "")
							.replace("-2025", "")
					: item.rowKey
							.replace("Commande-Semaine-", "")
							.replace("-2025", "");

				if (id < numeroSemaineEnCours) ancienne.push(item);
				else if (id > numeroSemaineEnCours) futur.push(item);
				else actuelle.push(item);
			});

			if (actuelle.length) {
				const dateTime1 = dayjs(
					`${actuelle[0].debutVente}-2025 09:00`,
					"DD-MM-YYYY HH:mm"
				);
				const dateTime2 = dayjs(
					`${actuelle[0].finVente}-2025 10:00`,
					"DD-MM-YYYY HH:mm"
				);
				const start = dayjs().isBefore(dateTime1) ? dateTime1 : dayjs();
				const end = dateTime2;
				const diff = end.diff(start);
				const isOpen = { open: diff <= 0 ? false : true };

				const dataVente = { ...actuelle[0], ...isOpen };
				setActuelleData(dataVente);
			} else {
				setActuelleData("no" + type);
			}
			setAncienneData(ancienne);

			setFuturData(futur);
		};
		data && sortingData();
	}, [data, type, numeroSemaineEnCours]);

	return { ancienneData, actuelleData, futurData };
}
